<template>
  <d-page>
    <ul class="base-info">
      <li class="field">
        <p>查看设备信息或电话权限</p>
        <span class="text">已允许</span>
        <img class="field-right" src="@/assets/images/icon/right.png" alt="" />
      </li>
      <li class="field">
        <p>获取储存权限空间</p>
        <span class="renew">去设置</span>
        <img class="field-right" src="@/assets/images/icon/right.png" alt="" />
      </li>
      <li class="field">
        <p>查看位置信息权限</p>
        <span class="renew">去设置</span>
        <img class="field-right" src="@/assets/images/icon/right.png" alt="" />
      </li>
      <li class="field">
        <p>使用相机权限</p>
        <span class="renew">去设置</span>
        <img class="field-right" src="@/assets/images/icon/right.png" alt="" />
      </li>
      <li class="field">
        <p>使用麦克风权限</p>
        <span class="renew">去设置</span>
        <img class="field-right" src="@/assets/images/icon/right.png" alt="" />
      </li>
    </ul>
    <ul class="base-info">
      <router-link tag="li" :to="{ path: '/mine/protocol' }" class="field border">
        <p>用户协议</p>
        <img class="field-right" src="@/assets/images/icon/right.png" alt="" />
      </router-link>
      <li class="field">
        <p>隐私政策</p>
        <img class="field-right" src="@/assets/images/icon/right.png" alt="" />
      </li>
    </ul>
  </d-page>
</template>

<script>
  export default {
    name: 'privacy',
    data() {
      return {}
    },
    methods: {}
  }
</script>

<style scoped lang="scss">
  .base-info {
    margin-top: 8px;

    .field {
      display: flex;
      align-items: center;
      position: relative;
      background: #ffffff;
      padding: 16px 12px;
      border-bottom: 8px solid #f5f5f5;
      box-sizing: border-box;

      p {
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
        line-height: 22px;
      }

      .icon {
        width: 20px;
        height: 20px;
        margin-right: 10px;
      }

      .field-right {
        position: absolute;
        right: 12px;
        width: 14px;
        height: 14px;
      }

      .renew {
        position: absolute;
        right: 30px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #2f83fb;
        line-height: 22px;
      }

      .text {
        position: absolute;
        right: 30px;
        line-height: 22px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;
        line-height: 20px;
      }

      &.border {
        border-bottom: 1px solid #f5f5f5;
      }

      &:last-child {
        border-bottom: 0;
      }
    }
  }
</style>
